export default function TelephonyApiKeyIcon() {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <mask
        id='mask0_49532_10885'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='24'
        height='24'
      >
        <rect width='24' height='24' fill='#D9D9D9' />
      </mask>
      <g mask='url(#mask0_49532_10885)'>
        <path
          d='M7 17.5C5.47217 17.5 4.17358 16.9655 3.10425 15.8965C2.03475 14.8275 1.5 13.5294 1.5 12.0023C1.5 10.4751 2.03475 9.17625 3.10425 8.10575C4.17358 7.03525 5.47217 6.5 7 6.5C8.03583 6.5 8.99608 6.775 9.88075 7.325C10.7654 7.875 11.4359 8.6 11.8923 9.5H22.5V14.5H20.5V17.5H15.5V14.5H11.8923C11.4359 15.4 10.7654 16.125 9.88075 16.675C8.99608 17.225 8.03583 17.5 7 17.5ZM7 16C8.1 16 8.98333 15.6625 9.65 14.9875C10.3167 14.3125 10.7167 13.65 10.85 13H17V16H19V13H21V11H10.85C10.7167 10.35 10.3167 9.6875 9.65 9.0125C8.98333 8.3375 8.1 8 7 8C5.9 8 4.95833 8.39167 4.175 9.175C3.39167 9.95833 3 10.9 3 12C3 13.1 3.39167 14.0417 4.175 14.825C4.95833 15.6083 5.9 16 7 16ZM7 13.6152C7.44417 13.6152 7.82442 13.4571 8.14075 13.1408C8.45708 12.8244 8.61525 12.4442 8.61525 12C8.61525 11.5558 8.45708 11.1756 8.14075 10.8593C7.82442 10.5429 7.44417 10.3848 7 10.3848C6.55583 10.3848 6.17558 10.5429 5.85925 10.8593C5.54292 11.1756 5.38475 11.5558 5.38475 12C5.38475 12.4442 5.54292 12.8244 5.85925 13.1408C6.17558 13.4571 6.55583 13.6152 7 13.6152Z'
          fill='currentColor'
        />
      </g>
    </svg>
  );
}
